module.exports = __webpack_public_path__ + "static/media/kid-peace-sign-xmas-tree.448fac24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-peace-sign-xmas-tree.jpg
// module id = 807
// module chunks = 0